import React from 'react';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import EditorialNavigationHeader from './EditorialNavigationHeader';
import EditorialHeroSection from './EditorialHeroSection';
import EditorialServicesSection from './EditorialServicesSection';
import EditorialPhotoGallery from './EditorialPhotoGallery';
import EditorialTestimonialsSection from './EditorialTestimonialsSection';
import EditorialLocationHoursSection from './EditorialLocationHoursSection';
import EditorialGMBFeedSection from './EditorialGMBFeedSection';
import EditorialCategoryTags from './EditorialCategoryTags';
import EditorialRelatedServices from './EditorialRelatedServices';
import EditorialFooter from './EditorialFooter';
import { LocalBusinessSchema } from '../SchemaScript';
import extractSchemaData from '../../utils/extractSchemaData';

// Google Fonts import for editorial typography
const GoogleFontsLink = () => (
  <link
    href="https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;500;600;700&family=Space+Grotesk:wght@300;400;500;600;700&family=Space+Mono:wght@400;700&display=swap"
    rel="stylesheet"
  />
);

const TemplateContainer = styled(Box)({
  width: '100%',
  minHeight: '100vh',
  backgroundColor: '#FAF8F5' // Cream background
});

const Template3 = ({
  templateData,
  isEditable = false,
  onTemplateUpdate
}) => {
  const {
    businessInfo,
    services,
    products,
    photos,
    testimonials,
    contactInfo,
    location,
    gmbFeed,
    categories,
    keywordsData,
    businessHours
  } = templateData || {};

  // Only render sections with real data
  const hasBusinessInfo = businessInfo?.name;
  const hasServices = services && services.length > 0;
  const hasPhotos = photos && photos.length > 0;
  const hasTestimonials = testimonials && testimonials.length > 0;
  const hasContactInfo = contactInfo && (contactInfo.address || contactInfo.phone);
  const hasGMBFeed = gmbFeed && gmbFeed.posts && gmbFeed.posts.length > 0;

  // Extract schema data for LocalBusiness structured data
  const schemaData = extractSchemaData(templateData);

  return (
    <>
      <GoogleFontsLink />
      {schemaData && <LocalBusinessSchema business={schemaData} />}
      <TemplateContainer>
        {hasBusinessInfo && (
          <EditorialNavigationHeader businessInfo={businessInfo} />
        )}

        {hasBusinessInfo && (
          <EditorialHeroSection
            businessInfo={businessInfo}
            heroImage={hasPhotos ? photos[0]?.url : null}
          />
        )}

        {hasServices && (
          <EditorialServicesSection services={services} />
        )}

        {hasPhotos && (
          <EditorialPhotoGallery photos={photos} />
        )}

        {hasTestimonials && (
          <EditorialTestimonialsSection
            testimonials={testimonials}
            businessInfo={businessInfo}
          />
        )}

        {hasContactInfo && (
          <EditorialLocationHoursSection
            contactInfo={contactInfo}
            location={location}
            businessHours={businessHours}
          />
        )}

        {hasGMBFeed && (
          <EditorialGMBFeedSection gmbFeed={gmbFeed} />
        )}

        <EditorialCategoryTags
          businessInfo={businessInfo}
          categories={categories}
          services={services}
          products={products}
          keywordsData={keywordsData}
        />

        <EditorialRelatedServices
          businessInfo={businessInfo}
          contactInfo={contactInfo}
          categories={categories}
          currentSlug={templateData?.slug}
        />

        <EditorialFooter
          businessInfo={businessInfo}
          contactInfo={contactInfo}
        />
      </TemplateContainer>
    </>
  );
};

export default Template3;
